import { useSelector } from 'react-redux'

import { useNumPortions } from 'hooks/basket/useNumPortions'
import { useMaxRecipesForPortion } from 'hooks/menu-boxes/useMaxRecipesForPortion'
import { getBasketRecipesCount } from 'selectors/basket'

export const useNumRecipesOverBasketLimit = (): number => {
  const { numPortions } = useNumPortions()
  const maxRecipesAllowedForPortionSize = useMaxRecipesForPortion(numPortions)

  const totalRecipesInBasket = useSelector(getBasketRecipesCount)

  return Math.max(totalRecipesInBasket - maxRecipesAllowedForPortionSize, 0)
}
